/**
 * Control styling for the Deliveries filter panel.
 *
 * CR-6450: extracted so the customer layout (DeliveryFilterSection) and the
 * supplier layout (DeliveryFilterSupplierLayout) render identical controls and
 * can't drift apart visually.
 *
 * Section headings are NOT here — those come from the app-wide
 * `components/filters/FilterSection`, so every reworked panel groups its
 * filters the same way. What remains is this panel's control density: the
 * Deliveries filters sit above a wide data grid and are deliberately more
 * compact than the dashboard's, so the input/label sizing is local.
 */
// CR-6442: padding updated to match SearchableSelect component (px-3 py-2.5)
// so native <select> and <input> elements have the same height as SearchableSelect.
export const inputCls =
  'w-full px-3 py-2.5 text-sm border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-background';
export const labelCls = 'text-xs font-medium mb-1 block text-foreground';
export const dateWrap = 'relative';
export const dateInputCls =
  'w-full pl-8 pr-3 py-2.5 text-sm border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-background';
export const gridCls = 'grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-3';
